import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { MatDialogRef } from "@angular/material/dialog";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../env-config";

let self: ReportService;

@Injectable()
export class ReportService {
  dialogRef!: MatDialogRef<any>;

  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) {
    self = this;
  }

  getTimeTrackByClient(query: any): Observable<any> {
    query.company = this._AuthService.companyId();
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    return this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/reports/totalHsByClient${queryParams}`);
  }

  exportgetTimeTrackByClient(query: any) {
    query.company = this._AuthService.companyId();
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/reports/totalHsByClient/export${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/xlsx", 'reporte-totalhs-por-cliente-' + new Date().getTime() + '.xlsx');
    });
  }

  getTimeTrackByWorker(query: any): Observable<any> {
    query.company = this._AuthService.companyId();
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    return this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/reports/totalHsByWorker${queryParams}`);
  }

  exportgetTimeTrackByWorker(query: any) {
    query.company = this._AuthService.companyId();
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/reports/totalHsByWorker/export${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/xlsx", 'reporte-totalhs-por-trabajador-' + new Date().getTime() + '.xlsx');
    });
  }

}